import { useRef } from 'react';

/**
 * Custom hook that produces a stable reference to a controller.
 *
 * @param factory An argument-less function that creates the controller.
 *
 * @return A stable reference to the created controller.
 */
export function useController<T>(factory: () => T): T {
  const controllerRef = useRef<T | null>(null);
  if (controllerRef.current == null) {
    controllerRef.current = factory();
  }
  return controllerRef.current;
}
